// Import model
import { FilterOtgCarpetCatalogStyleRequest } from '../models/FilterOtgCarpetCatalogStyleRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { OtgCarpetCatalogStyleCondition } from '../models/OtgCarpetCatalogStyleCondition';
import { OtgCarpetCatalogStyleFields } from '../models/OtgCarpetCatalogStyleFields';
import { OtgCarpetCatalogStyleIndexedFields } from '../models/OtgCarpetCatalogStyleIndexedFields';

// Import dependency serializers (for complex types)
import { OtgCarpetCatalogStyleConditionSerializer } from './OtgCarpetCatalogStyleConditionSerializer';
import { OtgCarpetCatalogStyleFieldsSerializer } from './OtgCarpetCatalogStyleFieldsSerializer';
import { OtgCarpetCatalogStyleIndexedFieldsSerializer } from './OtgCarpetCatalogStyleIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterOtgCarpetCatalogStyleRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterOtgCarpetCatalogStyleRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterOtgCarpetCatalogStyleRequest instance
   */
  static deserialize(json: string): FilterOtgCarpetCatalogStyleRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterOtgCarpetCatalogStyleRequest instance
   */
  static fromObject(obj: any): FilterOtgCarpetCatalogStyleRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterOtgCarpetCatalogStyleRequest');
    }


    const instance: FilterOtgCarpetCatalogStyleRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as OtgCarpetCatalogStyleIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as OtgCarpetCatalogStyleFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        OtgCarpetCatalogStyleConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterOtgCarpetCatalogStyleRequest instances
   */
  static deserializeArray(json: string): FilterOtgCarpetCatalogStyleRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterOtgCarpetCatalogStyleRequest instance to a JSON string
   */
  static serialize(instance: FilterOtgCarpetCatalogStyleRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterOtgCarpetCatalogStyleRequest instance to a plain object
   */
  static toObject(instance: FilterOtgCarpetCatalogStyleRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        OtgCarpetCatalogStyleConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterOtgCarpetCatalogStyleRequest instances to a JSON string
   */
  static serializeArray(instances: FilterOtgCarpetCatalogStyleRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
